// import React from "react";

// import Slider from "react-slick";
// import { useGSAP } from "@gsap/react";
// import gsap from 'gsap'
// import Lenis from 'lenis'
// import { ScrollTrigger } from 'gsap/all';
// import SplitType from 'split-type'\

// import banner01 from "../assets/images/Team-layout-background.webp"
// import banner02 from "../assets/images/Team/4142.jpg"
// import banner03 from "../assets/images/Team/4148.jpg"
import coreteam from "../assets/images/Home/Ourteam/team-2.webp"

import AnimatedText from "../component/animation";
// import FadeInOnScroll from "../component/scrollanimation";


import ContactForm from '../component/form-contact';
import Header from "../component/header";
import Footer from "../component/footer"; 

import team01 from "../assets/images/Team/Avenash-Kumar.webp"
import team02 from "../assets/images/Team/Akhilesh-V.webp"
import team03 from "../assets/images/Team/Philip-George-K.webp"


import director   from '../assets/images/Team/Managing-Director.webp'


function Teams() {




    // var settings = {
    //     dots: false,
    //     infinite: true,
    //     arrow: false,
    //     speed: 2000,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     cssEase: 'linear',
    //     autoplay: true,
    //     autoplaySpeed: 2000,
    //   };

    return (
          <section>
            <Header/>
            <main>
              
             {/* <div className="section-without-top-spacing --banner-images">
                 <Slider {...settings}>
                    <img className="banner-img" src={banner01} alt="banner-team" />
                    <img className="banner-img" src={banner02} alt="banner-team" />
                    <img className="banner-img" src={banner03} alt="banner-team" />
                 </Slider>
         </div> */}

           <div className="section section-title-center location-banner ">
                    <div className="base-container w-container section-scroll-animation">
                        <h1>Meet Our Team</h1>
                         <p className="_w-69"><AnimatedText text="Discover the people who power Arkane Engineering leaders and experts united by a shared commitment to precision, integrity, and exceptional engineering." animationType="fade-up" />
                            </p>
                    </div>

                         
                <div className="section-without-top-spacing first-story-section">
                     <img className="banner-img" src={coreteam} alt={coreteam}/>
                </div>
                 
                   </div>
                
            
         <div className="section  backgrounds-gray  object-container first-story-section">
          <div className="base-container w-container">
             

              <div className="w-layout-grid best-content-wrapper">

                  <div className="img-content px-600">
                    
                            <img src={director} alt="Bottle of beer" className="team-image" />
                    
                     
                  </div>
                  <div className="best-content-wrap animate-section-trigger">
                      <div className="bestcontent">
                         
                                 <h2 className="primary-text"><AnimatedText text="Our Core Team" animationType="rotate" /></h2>
                                 <p className="_w-69"><AnimatedText text="Our work demands precision, commitment, and deep technical expertise and I am proud to have a team that embodies all three. Our engineers and fabricators are not only highly qualified and skilled in their respective domains, but they also bring a strong sense of dedication and customer focus to every project we undertake." animationType="fade-up" /></p>
                                 <p className="_w-69"><AnimatedText text="Each member of our team works with the shared goal of delivering solutions that meet and often exceed our clients’ expectations. Their professionalism, attention to detail, and passion for excellence form the backbone of our organization." animationType="fade-up" /></p>
                                 <p className="_w-69"><AnimatedText text="From the beginning, I have always aimed to foster a healthy, inspiring, and collaborative work environment. Today, I am proud to say that our team reflects those values. We are like-minded individuals driven by the same purpose: to build high-quality, reliable process solutions that our clients can trust." animationType="fade-up" /></p>
                         
                      </div>
                  </div>

              </div>
          </div>
      </div>

      
      <div className="section object-container section-scroll-animation">
          <div className="base-container w-container">
              <div className="section-title-center">
                  <h2 className="primary-text"> Our All-Star Squad </h2>
                     <p>
                             <AnimatedText text="Discover the people who power Arkane Engineering leaders and experts united by a shared commitment to precision, integrity, and exceptional engineering." animationType="fade-up" />
                          </p>

              </div>
              <div className="layout-services layout-teams animate-section-trigger">
                  
    <div className="services-items">
                      <img src={team01}
                          alt="Service 1" className="service-img" />
                      <span className="service-title">
                          <span className="--h4"><AnimatedText text="Avenash Kumar V" animationType="rotate" /></span>
                          <span className="--h6"><AnimatedText text="Founder & Managing Director" animationType="scale" /></span>
                           <p>
                             <AnimatedText text="With 20+ years shaping stainless-steel manufacturing, he guides Arkane with bold leadership, deep expertise, and a passion for building cutting-edge process solutions." animationType="fade-up" />
                          </p>
                        <div className="socila-media">
                               <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/avenash-kumar-b58b2831/"><i className="fab fa-linkedin"></i></a>
                               <a target="_blank" rel="noreferrer" href="https://www.instagram.com/avenashkumar/"><i className="fab fa-instagram"></i></a>
                      </div>
                      </span>
                  </div>
                  
              
 <div className="services-items">
                      <img src={team02}
                          alt="Service 1" className="service-img" />
                      <span className="service-title">
                          <span className="--h4"><AnimatedText text="Akhilesh V" animationType="rotate" /></span>
                          <span className="--h6"><AnimatedText text="Plant Head" animationType="scale" /></span>
                         <p>
                             <AnimatedText text="Backed by two decades in aeronautical manufacturing at HAL, he drives high-performance operations and uncompromising production standards at Arkane." animationType="fade-up" />
                          </p>
                              <div className="socila-media">
                                   <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/akhilesh1411/"><i className="fab fa-linkedin"></i></a>
                                   <a target="_blank" rel="noreferrer" href="https://www.instagram.com/akhilesh141181/"><i className="fab fa-instagram"></i></a>
                      </div>
                      </span>
                  </div>
              
                  
  <div className="services-items">
                      <img src={team03}
                          alt="Service 1" className="service-img" />
                      <span className="service-title">
                          <span className="--h4"><AnimatedText text="Philip George K" animationType="rotate" /></span>
                          <span className="--h6"><AnimatedText text="Plant Manager" animationType="scale" /></span>
                           <p>
                             <AnimatedText text="Bringing ten years of industry experience, he has driven Arkane’s plant operations for seven years with disciplined & results-focused leadership." animationType="fade-up" />
                          </p>
                            <div className="socila-media">
                          <a target="_blank" rel="noreferrer" href=" https://www.linkedin.com/in/philip-george-k-886a2a206/"><i className="fab fa-linkedin"></i></a>
                      </div>
                      </span>
                  </div>
                  
                  
          
              </div>

          </div>
      </div>
                 <ContactForm/>
            </main>
            <Footer/>
        </section>
    )
}

export default Teams;